import axios from 'axios'

export default function (appConfig) {
  const configModule = {
    namespaced: true,
    state: {
      cities: null,
      categories: null,
      fees: null,
      selectedCity: null
    },
    mutations: {
      setCities (state, cities) {
        let newCities = {}
        cities.forEach(city => {
          newCities[city.id] = city.name
        })
        state.cities = newCities
      },
      setCategories (state, categories) {
        state.categories = categories
      },
      setFees (state, fees) {
        state.fees = fees
      },
      setSelectedCity (state, city) {
        state.selectedCity = city
      }
    },
    actions: {
      initialize (context) {
        context.dispatch('getCities')
        context.dispatch('getCategories')
      },
      getCategories (context) {
        return axios
          .get(`${appConfig.API_URL}/products/categories`)
          .then(result => {
            context.commit('setCategories', result.data)
          })
      },
      getCities (context) {
        return axios
          .get(`${appConfig.API_URL}/config/cities`, {
            params: {
              provinceName: 'Metro Manila'
            }
          })
          .then(result => {
            context.commit('setCities', result.data)
            return result.data
          })
      },
      getFees (context) {
        return axios
          .get(`${appConfig.API_URL}/config/fees`)
          .then(result => {
            context.commit('setFees', result.data)
            return result.data
          })
      }
    }
  }

  return configModule
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js